var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.type ? ("border-" + _vm.type) : ''},[(_vm.hasHeader)?_c('div',{staticClass:"card-header",class:_vm.type ? [
      ("border-" + _vm.type),
      ("bg-" + _vm.type),
      _vm.type !== 'light' ? 'text-white' : ''
    ] : ''},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasFooter)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }